export class MaterialDispatchDetails
{
    requirementDetailID:any;
    jobNumber:string;
    rmhName:string;
    rmhid:string;
    jobType:string;
    JobTypeID:any;
    brand:string;
    BrandID:any;
    crop:string;
    CropID:any;
    language:string;
    LanguageID:any;
    state:string;
    stateCode:any;
    month:string
    requestedQuantity:any;
    availableInInventory:any;
    finalQuantity:any;
    approvedQuantity:any;
    deliveryDeadline:any;
    status:any;
    statusID:number;
    allocatedQuantity:number;
    totalRemaining:number;
    requirementType:number;
    transportName:any;
    dispatchDate:any;
    dispatchLocation:any;
    dispatchAddress:any;
    noOfBoxes:number;
    quantityDispatched:number;
    estimatedDeliveryDate:any;
    remarks:any;
    mobileNumber:any;
    isSelected:boolean=false;
    isConfirmReceipt:boolean;
    materialAllocationDone:boolean;
}
export class UserDetails
{
    requirementDetailID:number;
    jobNumber:string;
    userName:any;
    userID:any;
    userRole:any;
    mobileNumber:any;
    allocateID:number;
    allocatedQuantity:number;
    transportName:string;
    dispatchDate:Date;
    dispatchLocation:string;
    dispatchAddress:string;
    noOfBoxes:number;
    quantityDispatched:number;
    estimatedDeliveryDate:Date;
    remarks:string;
    isDispatchSaved:boolean;
    statusID:number;
    requirementType:Number;
    totalRemaining:number;
    regioncode:string;
    poIssuedQuantity:number;
    availableInInventory:any;
}
export class Documents {
    file:File;
}


